export default {"src":"/_next/static/media/close-navigation.fcbec551.svg","height":10,"width":10};